import {
  AccApplyStatusDto,
  AccResultRecordDto,
  AccResultRecordRs,
} from '@domain/rs/acca/v1/test/result/AccResultRecordRs';
import { VersionType } from '@domain/constant/acca/test/result/versionType';
import { ProgressType } from '@domain/constant/acca/test/result/progressType';
import { CompetenceType } from '@domain/constant/acca/test/result/competenceType';
import { AnalysisType } from '@domain/constant/analysisType';
import { ResultType } from '@domain/constant/acca/test/result/resultType';

export class AccResultRecordVO {
  sn: number;
  name: string; //응시명
  code: string; // 응시 코드
  version: VersionType; // 결과표 버전 V1(결과표 개발 이전 버전), V2(결과표 개발 이후 버전)
  analysisType: AnalysisType; // 분석 상태
  resultType: ResultType; // 분석 결과 상태
  applicationDate: string;
  externalYn: boolean; //잡다, 기업용 역검 여부

  constructor(rs: AccResultRecordDto) {
    this.sn = rs.sn;
    this.code = rs.code;
    this.name = rs.name;
    this.version = rs.version;
    this.analysisType = rs.analysisType;
    this.resultType = rs.resultType;
    this.applicationDate = rs.applicationDate;
    this.externalYn = rs.externalYn;
  }
}

export class AccApplyStatusVO {
  code: string;
  version: VersionType;
  progressType: ProgressType;

  constructor(rs: AccApplyStatusDto) {
    this.code = rs.code;
    this.version = rs.version;
    this.progressType = rs.progressType;
  }
}

export class AccResultVO {
  url: string; // 응시 도메인
  chanceCount: number; // 응시 기회
  resultRecords: AccResultRecordVO[] | null; // 이전 응시 기록 목록
  applyStatus: AccApplyStatusVO | null; // 응시 상태
  profileResultType: CompetenceType; // 최근 분석 완료된 결과의 역량 유형

  constructor(rs: AccResultRecordRs) {
    this.url = rs.url;
    this.chanceCount = rs.chanceCount;
    this.resultRecords = rs.resultRecords.map((resultRecord) => new AccResultRecordVO(resultRecord));
    this.applyStatus = rs.applyStatus;
    this.profileResultType = rs.profileResultType;
  }
}
